import React from "react";

import { Box, Typography } from "@mui/material";

interface Props {
  step: number;
  isCloudMirror?: boolean;
}

const stepTitles = ["Add files", "Review and organize"];
const stepDescriptions = [
  "Select deal, destination folder and add files",
  "Select the investor, file type and action for each file."
];

const cloudMirrorStepTitles = ["Add files", "Review and organize"];
const cloudMirrorStepDescriptions = [
  "Select files to upload",
  "Assign deal, classification & details for each file."
];

export const StepIndicator: React.FC<Props> = ({ step, isCloudMirror }) => {
  const stepIndex = step - 1;
  const titles = isCloudMirror ? cloudMirrorStepTitles : stepTitles;
  const descriptions = isCloudMirror ? cloudMirrorStepDescriptions : stepDescriptions;
  return (
    <Box>
      <Typography
        sx={{
          fontSize: "15px",
          fontWeight: 500,
          lineHeight: "20px",
          color: "#071f35",
          mb: "3px"
        }}
      >
        Step {step}: {titles[stepIndex]}
      </Typography>
      <Typography sx={{ fontSize: "14px", lineHeight: "16px", color: "#496682" }}>
        {descriptions[stepIndex]}
      </Typography>
    </Box>
  );
};
